


















































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import AddStadium from "@/views/stadium/add.vue";
import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit,
    AddStadium
  }
})
export default class extends Mixins(MyList) {
  addStadiumVisible = false;

  dispatchType = "customer/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "主体名称", dataIndex: "customer_name" },
    { title: "场馆数量", dataIndex: "stadium_count" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showAddStadiumModal(id: number) {
    this.editId = id;
    this.addStadiumVisible = true;
  }

  hideAddStadiumModal() {
    this.addStadiumVisible = false;
    this.loadData();
  }

  mounted() {
    this.loadData();
  }
}
